import { NavLink, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import OpsDashboard from './OpsDashboard';
import RaiseTicket from './RaiseTicket';
import TicketDetail from './TicketDetail';
import TrackTickets from './TrackTickets';

function getHomePath() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const role = user?.role?.toLowerCase();
    if (role === 'super_admin') return '/super-admin/super-admin-dashboard';
    if (role === 'guest') return '/guest/dashboard';
    if (user?.role) return '/tenant/dashboard';
  } catch {
    // Fall back to the login route when local storage is unavailable or malformed.
  }

  return '/login';
}

export default function TicketTracker() {
  const navigate = useNavigate();

  return (
    <div className="tickets-shell">
      <header className="ticket-topbar">
        <div className="ticket-brand">
          <span className="ticket-logo">SIMB</span>
          <span className="ticket-brand-text">Ticket Tracker</span>
        </div>
        <nav className="ticket-nav">
          <button type="button" className="ticket-home-button" onClick={() => navigate(getHomePath())}>Home</button>
          <NavLink to="/tickets/raise">Raise Ticket</NavLink>
          <NavLink to="/tickets/track">Track Tickets</NavLink>
          <NavLink to="/tickets/dashboard">Ops Dashboard</NavLink>
        </nav>
      </header>
      <main className="ticket-content">
        <Routes>
          <Route index element={<Navigate to="/tickets/raise" replace />} />
          <Route path="raise" element={<RaiseTicket />} />
          <Route path="track" element={<TrackTickets />} />
          <Route path="dashboard" element={<OpsDashboard />} />
          <Route path="view/:id" element={<TicketDetail />} />
        </Routes>
      </main>
      <footer className="ticket-footer">
        SLA: respond within 48h - resolve within 5 days - standard operations only
      </footer>
    </div>
  );
}
